module.exports = __webpack_public_path__ + "static/media/Home Page_website-22.1e6f371d.png";